/**
 * @file 手百调起相关
 */
import PlatUtil from '../utils/platUtil';
import Tool from '../utils/tool';

const BdboxInvoke = {
    callbackId: 0,

    /**
     * 端回调js，处理的全局js名称
     *
     * @private
     * @return {Number} id
     */
    getId: () => BdboxInvoke.callbackId++,

    /**
     * 生成手百调起scheme
     *
     * @private
     * @param {Object} data 吊起相关参数
     * @param {Object} data.action 吊起核心参数。
     * @param {Object} data.downloadInfo 下载信息。
     * @param {Object} data.pagepd 渠道相关信息。统计相关。
     */
    createBdboxAppScheme: ({action, source, id}) => {
        let scheme = '';

        if (action.searchQuery) {
            scheme = PlatUtil.isIos()
                ? BdboxInvoke.getBdIOSBackSearchScheme(id, source, action.searchQuery)
                : BdboxInvoke.getBdAndrCmd(id, source);
        }
        else if (/^\d+$/.test(id)) {
            scheme = PlatUtil.isIos()
                ? BdboxInvoke.getBdIOSBackChannelScheme(id, source)
                : BdboxInvoke.getBdAndrBackChannelScheme(id, source);
        }
        else {
            scheme = PlatUtil.isIos()
                ? BdboxInvoke.getBdIOSV80Scheme(id, source)
                : BdboxInvoke.getBdAndrCmd(id, source);
        }

        return scheme;
    },

    /**
    * 手百新调起函数
    *
    * @param {Object} action 调起行为
    * @param {Object} params 调起参数
    * @param {Function} callbackFn 回调
    */
    newInvoke: (action, params, callbackFn) => {
        if (!action || !(window.Box && window.Box.isBox)) {
            return;
        }

        let url = [];
        let callback = callbackFn;
        if (typeof params === 'function') {
            callback = params;
        }
        else {
            Object.keys(params).map(item => {
                if (Object.prototype.hasOwnProperty.call(params, item)) {
                    url.push(`${item}=${params[item]}`);
                }
                return false;
            });
        }
        if (typeof callback === 'function') {
            const funcName = `_bdbox_js_${BdboxInvoke.getId()}`;
            const argumentsObj = {0: action, 1: params, 2: callbackFn, length: 3};
            window[funcName] = function () {
                callback.apply(window, ([]).slice.call(argumentsObj, 0));
            };
            url.push(`callback=${funcName}`);
        }
        else if (callback) {
            url.push(`callback=${callback}`);
        }
        url = `baiduboxapp://${action}?${url.join('&')}`;

        let $node = document.createElement('iframe');
        $node.style.display = 'none';
        $node.src = url;
        const body = document.body || document.getElementsByTagName('body')[0];
        body.appendChild($node);
        // 销毁 iframe
        setTimeout(() => {
            body.removeChild($node);
            $node = null;
        }, 0);
    },

    /**
     * 注入boxJS
     *
     * @private
     * @param {Object} injectBoxJSOption 整合boxjs与box
     * @param {Object} injectBoxJSOption.boxJS boxjs
     * @param {Object}injectBoxJSOption.box box
     * @return {Object} boxjs
     */
    getBoxJS: injectBoxJSOption => {
        const boxJS = (injectBoxJSOption && injectBoxJSOption.boxJS) || window.BoxJS;
        const box = (injectBoxJSOption && injectBoxJSOption.box) || window.Box;
        if (!box && !boxJS) {
            return null;
        }
        return {
            isBox: () => {
                if (boxJS) {
                    return !!boxJS.isBox;
                }
                return !!box.isBox;
            },
            invokeAndroid: () => {
                if (boxJS) {
                    boxJS.invokeAndroid(...arguments);
                }
                box && box.android && box.android.invokeApp
                    && (box.android.invokeApp(...arguments));
            },
            versionCompare: () => {
                if (boxJS) {
                    return boxJS.version_compare(...arguments);
                }
                return box.version_compare.apply(boxJS, arguments) || 0;
            },
            getVersion: () => {
                if (boxJS) {
                    return boxJS.getVersion();
                }
                return box.version;
            }
        };
    },

    /**
    * 判断是否大于给出的手百版本号
    *
    * @param {string} base 基准版本号
    * @return {number} 1：大于等于 ，0：小于， -1：无法判断
    */
    boxVerCompare: base => {
        const boxUtils = window.Box || window.BoxJS;
        if (boxUtils) {
            return boxUtils.version_compare(boxUtils.version || boxUtils.getVersion(), base) >= 0 ? 1 : 0;
        }
        return -1;
    },

    /**
     * 拼接手百视频落地页地址
     *
     * @private
     * @param {string} id 视频的id,可以为locid,或者为nid
     * @param {Object} source 额外的参数,主要用于统计
     * @param {boolean} noInvokeVideo 是否调起播放器.用于安卓拼返回频道scheme
     * @return {string} landUrl 手百视频落地页地址
     */
    getBdLandUrl: (id, source, noInvokeVideo) => {
        let obj;
        if (id.indexOf('internal') > -1) {
            obj = {
                /* eslint-disable fecs-camelcase */
                internal_url: id
                /* eslint-enable fecs-camelcase */
            };
        }
        else {
            obj = {
                nid: id.indexOf('sv') > -1 ? id : (`sv_${id}`)
            };
        }

        let extra = '&backflow=1';
        if (Tool.isObject(source)) {
            Object.keys(source).map(item => {
                if (Object.prototype.hasOwnProperty.call(source, item)) {
                    extra += `&${item}=${source[item]}`;
                }
                return false;
            });
        }
        if (noInvokeVideo) {
            extra += '&no_invoke_video=1';
        }
        const landUrl = `https://sv.baidu.com/videoui/page/videoland?context=${encodeURIComponent(JSON.stringify(obj))}${extra}`;

        return landUrl;
    },


    /**
     * 拼接手百iOS吊起scheme,用于手百吊起组件
     *
     * @private
     * @param {string} id 视频的id,可以为locid,或者为nid
     * @param {Object} source 额外的参数,主要用于统计
     * @return {string} iosScheme 传入手百组件的手百iOS吊起scheme
     */
    getBdIOSV80Scheme: (id, source) => {
        const landUrl = BdboxInvoke.getBdLandUrl(id, source);
        const iosSheme = `baiduboxapp://easybrowse?openurl=
            ${encodeURIComponent(landUrl)}
            &opentype=1
            &isla=0
            &type=video
            &page_type=empty
            &newbrowser=1
            &sfrom=feed
            &append=1
            &stay=1
            &minver=6.0.0.0
            &toolbaricons=%7B%22toolids%22%3A%5B%221%22%2C%222%22%2C%223%22%5D%7D
            &menumode=2`;

        return iosSheme;
    },

    /**
     * 拼接手百Android吊起cmd,用于手百吊起组件
     *
     * @private
     * @param {string} id 视频的id,可以为locid,或者为nid
     * @param {Object} source 额外的参数,主要用于统计
     * @return {Object} andrCmd 传入手百组件的手百Android吊起cmd
     */
    getBdAndrCmd: (id, source) => {
        const landUrl = BdboxInvoke.getBdLandUrl(id, source);
        /* eslint-disable max-len */
        const intent = `intent:#Intent;component=com.baidu.searchbox/.home.feed.ShortVideoDetailActivity;B.bdsb_append_param=true;S.bdsb_light_start_url=${encodeURIComponent(landUrl)};S.toolbaricons=%7B%22toolids%22%3A%5B%221%22%2C%222%22%2C%223%22%5D%7D;S.menumode=2;end`;
        /* eslint-enable max-len */
        const andrCmd = {
            mode: '0',
            intent,
            /* eslint-disable fecs-camelcase */
            min_v: '16787968'
            /* eslint-enable fecs-camelcase */
        };
        return andrCmd;
    },

    /**
     * 拼接手百双端吊起scheme,仅限8.2以上
     *
     * @private
     * @param {string} id 视频的id,可以为locid,或者为nid
     * @param {Object} source 额外的参数,主要用于统计
     * @param {boolean} noInvokeVideo 是否禁止调起播放器.仅限android h5落地页->NA频道->NA落地页的方式使用
     * @return {string} iosScheme 传入手百组件的手百iOS吊起scheme
     */
    getBdV82Scheme: (id, source, noInvokeVideo) => {
        const landUrl = BdboxInvoke.getBdLandUrl(id, source, noInvokeVideo);
        /* eslint-disable max-len */
        const scheme = `baiduboxapp://v1/easybrowse/open?
            upgrade=1
            &type=video
            &url=${encodeURIComponent(landUrl)}
            &append=1
            &slog=%7b%22from%22%3a%22feed%22%7d
            &style=%7b%22toolbaricons%22%3a%7b%22toolids%22%3a%5b%221%22%2c%222%22%2c%223%22%5d%7d%2c+%22menumode%22%3a%222%22%7d
            &newbrowser=1
            &stay=1`;
        /* eslint-disable max-len */

        return scheme;
    },

    /**
     * 拼接手百Android吊起cmd,可直接进行吊起
     *
     * @private
     * @param {Object} cmd 视频的id,可以为locid,或者为nid
     * @return {string} invokeCmd 手百Android吊起cmd
     */
    getBdAndrInvokeCmd: cmd => {
        /* eslint-disable max-len */
        // eslint-disable-next-line no-useless-escape
        let params = '{"intent":"intent:#Intent;action=com.baidu.searchbox.action.HOME;component=com.baidu.searchbox\/.MainActivity';
        params = `${params};S.targetCommand=${encodeURIComponent(JSON.stringify(cmd))};end"}`;
        const invokeCmd = `baiduboxapp://utils?action=sendIntent&minver=7.4&params=${encodeURIComponent(params)}`;
        return invokeCmd;
        /* eslint-enable max-len */
    },

    /**
     * 拼接NA落地页吊起scheme,双端9.1支持. 但是只支持id调起
     *
     * @private
     * @param {string} id 视频的id,可以为locid,或者为nid
     * @param {string} playurl 视频的播放地址,安卓必需.注意防盗链风险
     * @param {string} pdParam 视频的来源渠道
     * @param {string} pagepd 视频的调起渠道
     * @return {string} invokeCmd 手百Android吊起cmd
     */
    getBdNALandScheme: (id, playurl, pdParam, pagepd) => {
        const pd = pdParam || 'growth';
        const protocol = 'baiduboxapp://v8/video/invokeVideoLandingPage';
        const params = {
            vid: `${id}`,
            videoInfo: {
                /* eslint-disable fecs-camelcase */
                ext_log: {
                    pd: pd || '',
                    pagepd: pagepd || ''
                },
                /* eslint-enable fecs-camelcase */
                ext: {
                    clarityUrl: [
                        {
                            key: 'sd',
                            rank: 0,
                            title: '标清',
                            url: playurl
                        }
                    ]

                }
            },
            pd
        };
        const tail = '&toolbaricons=%7B%22toolids%22%3A%5B%224%22%2C%221%22%2C%222%22%2C%223%22%5D%7D&menumode=2';
        return `${protocol}?params=${encodeURIComponent(JSON.stringify(params))}${tail}`;
    },

    /**
     * 拼接手百iOS调起H5落地页返回NA视频频道scheme
     *
     * @private
     * @param {string} id 视频的id,可以为locid,或者为nid
     * @param {Object} source 额外的参数,主要用于统计
     * @return {string} scheme 手百iOS吊起scheme
     */
    getBdIOSBackChannelScheme: (id, source) => {
        const landScheme = BdboxInvoke.getBdV82Scheme(id, source, false);
        const naChannelScheme = 'baiduboxapp://v11/appTab/select?item=video&upgrade=0&delaytime=0.6';
        return `${landScheme}&prev=${encodeURIComponent(naChannelScheme)}`;
    },

    /**
     * 拼接手百android调起scheme, NA落地页返回NA视频频道,低版本调起h5落地页
     *
     * @private
     * @param {string} id 视频的id,可以为locid,或者为nid
     * @param {Object} source 额外的参数,主要用于统计
     * @param {string} [playurl] 视频的url,视频播放地址
     * @return {string} scheme 手百iOS吊起scheme
     */
    getBdAndrBackChannelScheme: (id, source) => {
        // 手机百度在三星下有坑, 部分三星旧手机预装了8.1手百,会拦截高版本手百协议
        const isSamsung = /\(.*Android.*(SAMSUNG|SM-).*\)/.test(navigator.userAgent);
        if (isSamsung) {
            return BdboxInvoke.getBdAndrCmd(id, source);
        }
        const naChannelScheme = 'baiduboxapp://v11/appTab/select?item=video&upgrade=0';
        const landScheme = BdboxInvoke.getBdV82Scheme(id, source, true);
        const landSchemeInvoke = BdboxInvoke.getBdV82Scheme(id, source, false);

        const nextValue = `${naChannelScheme}&next=${encodeURIComponent(landSchemeInvoke)}`;
        return `${landScheme}&next=${encodeURIComponent(nextValue)}`;
    },

    /**
     * 拼接手百iOS调起scheme, H5落地页返回搜索页
     *
     * @private
     * @param {string} id 视频的id,可以为locid,或者为vid
     * @param {Object} source 额外的参数,主要用于统计
     * @param {string} query 搜索query
     * @return {string} scheme 手百iOS吊起scheme
     */
    getBdIOSBackSearchScheme: (id, source, query) => {
        const prevValue = `baiduboxapp://v1/browser/search?query=${encodeURIComponent(query)}`;
        const backSearchScheme = `${BdboxInvoke.getBdIOSV80Scheme(id, source)}&prev=${encodeURIComponent(prevValue)}`;
        return backSearchScheme;
    },

    /**
     * 手百APP吊起。最核心的吊起机制。
     *
     * @private
     * @param {Object} data 吊起相关参数
     * @param {Object} data.action 吊起核心参数
     * @param {string} data.action.type 值为:normalInvoke,表示不会引导下载;值为:invoke,表示正常吊起,吊起失败导下载。
     * @param {string} data.action.app 必须。值为:BdBox
     * @param {Object} data.pagepd 吊起渠道相关。统计需要
     * @param {Object} data.action.extra 额外配置
     * @param {Object} data.action.extra.failUrl data.action.type==='normalInvoke'时必须,传入手百组件的failUrl.
     * @param {Function} data.action.extra.failCallback data.action.type==='normalInvoke'时必须,传入手百组件的failCallback.
     *
     */
    bdInvoke: data => {
        const action = data.action;
        const pagepd = data.pagepd;
        let openBdBox = null;
        const opts = {
            showTip: false
        };

        if (action.app !== 'BdBox') {
            console.warn('Action.app is required for bdInvoke');
            return;
        }

        if (action.searchQuery) {
            opts.backQuery = action.searchQuery;
        }

        // 只进行手百的吊起,不进行下载
        if (action.type === 'normalInvoke') {
            if (!Tool.isObject(action.extra)) {
                console.warn('Extra info is required for invokeNormal');
                return;
            }
            const failUrl = action.extra.failUrl;
            const failCallback = action.extra.failCallback;
            opts.failUrl = failUrl;
            opts.failCallback = function () {
                console.log('invoke app failed');
                failCallback && failCallback();
            };
        }

        if (PlatUtil.isIos()) {
            opts.iosScheme = action.scheme;
        }
        else {
            opts.androidCommand = action.scheme;
        }
        pagepd && pagepd.channel && (opts.channel = pagepd.channel);
        pagepd && pagepd.from && (opts.from = pagepd.from);

        const openbox = window.OpenBox;
        if (openbox) {
            openBdBox = openbox(opts);
            openBdBox.open();
        }
    },

    /**
     * 手百内调起视频频道
     */
    invokeChannel: () => {
        const highVersion91 = BdboxInvoke.boxVerCompare('9.1');
        if (highVersion91 === 1) {
            BdboxInvoke.newInvoke('v11/appTab/select', {
                item: 'video',
                upgrade: 0
            });
        }
        else if (highVersion91 === 0) {
            BdboxInvoke.newInvoke('v1/easybrowse/open', {
                append: 1,
                newbrowser: 1,
                upgrade: 1,
                url: encodeURIComponent('https://sv.baidu.com')
            });
        }
    },

    /**
     * 是否安装手百手机助手插件
     *
     * @param {Function} cb 判断在手百内,并且安装手助插件的回调
     * @param {Object} [data] 调起数据
     * @param {Object} [data.injectBoxJSOption] 注入选项
     * @param {Object} [data.injectBoxJSOption.boxjs] 注入的boxjs
     * @param {Object} [data.injectBoxJSOption.box] 注入的box
     */
    isBdAppSearchInstalled: (cb, data) => {
        const boxJS = BdboxInvoke.getBoxJS(data && data.injectBoxJSOption);
        if (!boxJS || !boxJS.isBox() || boxJS.versionCompare(boxJS.getVersion(), '8.0') < 0) {
            cb(false);
            return;
        }

        window.fecommonGetInstalledPluginVersionCallback = function (back) {
            if (back !== -1 && back !== '-1') {
                cb(true);
            }
            else {
                cb(false);
            }
        };

        boxJS.invokeAndroid('Bdbox_android_plugin',
            'getInstalledPluginVersion', [
                JSON.stringify({
                    /* eslint-disable fecs-camelcase */
                    package_name: 'com.baidu.appsearch'
                    /* eslint-enable fecs-camelcase */
                }), 'window.fecommonGetInstalledPluginVersionCallback'
            ]);
    },

    /**
     * 手机助手打开app
     *
     * @param {Function} data 调起数据
     * @param {string} data.pkgName 应用包名
     * @param {Function} [data.injectBoxJSOption] 注入的boxjs
     */
    openBdAppSearch: data => {
        const boxJS = BdboxInvoke.getBoxJS(data && data.injectBoxJSOption);
        if (!boxJS || !boxJS.isBox() || !data.pkgName) {
            return;
        }
        const opt = {
            /* eslint-disable fecs-camelcase */
            package_name: 'com.baidu.appsearch',
            method_name: 'plugin_appsearch_invoker',
            by_user: 1,
            need_baidu_params: 0,
            /* eslint-enable fecs-camelcase */
            /* eslint-disable max-len */
            // eslint-disable-next-line no-useless-escape
            params: `{\"action\":\"com.baidu.searchbox.plugin.action.THIRD_INVOKE\",\"S.package_name\":\"com.baidu.appsearch\",\"S.method_name\":\"plugin_appsearch_invoker\",\"S.website_url\":\"\",\"S.by_user\":1,\"S.params\":\"{\\\"intent\\\":\\\"#Intent;action=com.baidu.appsearch.extinvoker.LITELAUNCH;S.backop=0;S.pkg=${data.pkgName};S.quitop=1;S.func=10;B.download_immediatly=true;i.download_mode=1;end\\\"}\",\"S.need_baidu_params\":0}`
            /* eslint-enable max-len */
        };

        boxJS.invokeAndroid(
            'Bdbox_android_plugin',
            'invokePlugin',
            [JSON.stringify(opt), 'console.log']
        );
    }

};
export default BdboxInvoke;
